'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CheckCircleFilled = _interopRequireDefault(require('./lib/icons/CheckCircleFilled'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _CheckCircleFilled;
exports.default = _default;
module.exports = _default;